<ng-container>
  <div class="row">
    <div class="content-header-container">
      <span class="content-header">{{ headerText }}</span>
    </div>
  </div>
</ng-container>
<div class="row" *ngIf="subtitle">
  <h2 class="card-header header-text">{{ subtitle }}</h2>
</div>
<ng-container *ngIf="classroomList; else loading">
  <ng-container *ngIf="classroomList.length > 0; else noClasses">
    <div class="card-list-container">
      <app-shared-classroom-card-smart
        *ngFor="let classListItem of classroomList"
        [classListItem]="classListItem"
      ></app-shared-classroom-card-smart>
    </div>
  </ng-container>
  <ng-template #noClasses>
    <div class="empty-classrooms">Currently not in a classroom!</div>
  </ng-template>
</ng-container>
<ng-template #loading>
  <div class="table">
    <div class="loader"></div>
  </div>
</ng-template>

<ng-container *ngIf="classroomCode">
  <app-dynamic-form
    [formConfig]="classroomCode"
    (emitForm)="propagateForm($event)"
    (emitSubmit)="submit()"
  ></app-dynamic-form>
</ng-container>
